// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2wXuq","log":"ModalInventoryLogs_log__2woaH","date":"ModalInventoryLogs_date__1ZMFv","userName":"ModalInventoryLogs_userName__2he3r"};